import { render, staticRenderFns } from "./FileViewer.vue?vue&type=template&id=0346bda6&scoped=true&lang=pug"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"
import style0 from "./FileViewer.vue?vue&type=style&index=0&id=0346bda6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0346bda6",
  null
  
)

export default component.exports